export default "__VITE_ASSET__q0cNnG9E__"